module.exports = __webpack_public_path__ + "static/media/ict4.9e0cccf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ict4.jpg
// module id = 5812
// module chunks = 0